import { ComponentChildren } from 'preact';
import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { classNames } from '../utils/UNSAFE_classNames';
import { UserAssistanceDensityType } from './InlineUserAssistance';
import {
  UserAssistanceStyles,
  UserAssistanceVariantOptions
} from './themes/UserAssistanceStyles.css';
import { useInputGroupContext } from '../hooks/UNSAFE_useInputGroupContext';
import { UserAssistanceRedwoodTheme } from './themes/redwood/UserAssistanceTheme';
import { TestIdProps, useTestId } from '#hooks/UNSAFE_useTestId';

type Props = {
  id?: string;
  children?: ComponentChildren;
  variant?: UserAssistanceDensityType;
} & TestIdProps;

// defaults to type='reflow'. If this is within an oj-form-layout, the o-f-l
// will pass down its type which defaults to 'efficient' (TODO).
export function InlineUserAssistanceContainer({ variant = 'reflow', children, id, testId }: Props) {
  const {
    classes,
    styles: { inlineContainerBaseStyles }
  } = useComponentTheme<UserAssistanceVariantOptions, UserAssistanceStyles>(
    UserAssistanceRedwoodTheme,
    {
      container: variant
    }
  );

  const testIdProps = useTestId(testId);

  // we want to suppress the display of messages if it's in a group context
  const inputGroupContext = useInputGroupContext();
  if (inputGroupContext !== null) return null;

  const content = (
    <div class={classNames([classes, inlineContainerBaseStyles])} id={id} {...testIdProps}>
      {children}
    </div>
  );

  return content;
}
